import mitt from 'mitt';

const eventBus = mitt();

// todo for fallbacks
eventBus.$on  = eventBus.on;
eventBus.$off = eventBus.off;
eventBus.$emit = eventBus.emit;

export default eventBus;